export const xCoordinatesReport12: number[] = [295, 386, 477, 567, 658]
export const xCoordinatesPeriod12: number[] = [427, 477, 501]
export const yCoordinatesPeriod12: number[] = [43, 64]
